module.exports = __webpack_public_path__ + "static/media/bg_img_p8_2.65e3e444.png";